import { z } from 'zod';

import { IMAGE_URL } from 'app/configs';
import { PublishType } from 'app/models/EmailNotifications';
import { MemberLevelType, UserJobTitleType, UserType } from 'app/models/User';

export const EMAIL_NOTIFICATION_FORM_SCHEMA = z
  .object({
    title: z
      .string()
      .min(1, { message: '必填' })
      .max(400, { message: '超出字數上限' }),
    // content: z
    //   .string(),
    // image: z
    //   .array(
    //     z.instanceof(File)
    //       .or(z.custom<FormPreviewItem>()),
    //   ),
    // json: z.string(),
    isPublishNow: z
      .custom<PublishType>(),
    scheduledTime: z
      .date()
      .nullable(),
    permission: z.object({
      CommercePermissions: z
        .array(
          z.object({
            userType: z
              .custom<UserType>()
              .nullable(),
            memberLevel: z
              .custom<MemberLevelType>()
              .nullable(),
            userTag: z
              .string()
              .nullable(),
            branchName: z
              .string()
              .nullable(),
            family: z
              .string()
              .nullable(),
            jobTitle: z
              .custom<UserJobTitleType>()
              .nullable(),
          }),
        ),
    }),
  })
  .refine(
    ({ isPublishNow, scheduledTime }) => isPublishNow === 'instant' || scheduledTime,
    { message: '必選', path: ['scheduledTime'] },
  );

export type EmailNotificationFormDataType = z.infer<typeof EMAIL_NOTIFICATION_FORM_SCHEMA>;

// export const INITIALIZED_NOTIFICATION_FORM_DATA: NotificationFormDataType = {
//   title: '',
//   description: '',
//   content: '',
//   image: [],
//   isPublishNow: 'instant',
//   scheduledTime: null,
//   notificationLinkType: null,
//   statementId: null,
//   shopId: null,
//   surveyId: null,
//   commerceItemId: null,
//   companyActivityId: null,
//   tags: [],
//   type: 'system',
//   url: '',
//   permission: { CommercePermissions: [INITIALIZED_COMMERCE_ITEM_PERMISSION] },
// };

export const EMAIL_TEMPLATE_DESIGN = {
  body: {
    id: '4xQU1Ik4GQ',
    rows: [
      {
        id: 'dnMN5EJVBl',
        cells: [
          1,
        ],
        values: {
          _meta: {
            htmlID: 'u_row_1',
            htmlClassNames: 'u_row',
          },
          anchor: '',
          columns: false,
          padding: '0px',
          hideable: true,
          deletable: true,
          draggable: true,
          selectable: true,
          _styleGuide: null,
          hideDesktop: false,
          duplicatable: true,
          backgroundColor: '',
          backgroundImage: {
            url: '',
            size: 'custom',
            repeat: 'no-repeat',
            position: 'center',
            fullWidth: true,
            customPosition: [
              '50%',
              '50%',
            ],
          },
          displayCondition: null,
          columnsBackgroundColor: '',
        },
        columns: [
          {
            id: '9kC3_YLh3I',
            values: {
              _meta: {
                htmlID: 'u_column_1',
                htmlClassNames: 'u_column',
              },
              border: {},
              padding: '0px',
              borderRadius: '0px',
              backgroundColor: '',
            },
            contents: [
              {
                id: '6FtPvFRq3Q',
                type: 'image',
                values: {
                  src: {
                    url: `${IMAGE_URL}/original/svgroup_app_93617191cbd6d876b147a7d1e2aee0b4e69850b83435e634.png`,
                    width: 119,
                    height: 112,
                  },
                  _meta: {
                    htmlID: 'u_content_image_1',
                    htmlClassNames: 'u_content_image',
                  },
                  action: {
                    name: 'web',
                    values: {
                      href: '',
                      target: '_blank',
                    },
                  },
                  anchor: '',
                  altText: '',
                  pending: false,
                  hideable: true,
                  deletable: true,
                  draggable: true,
                  textAlign: 'center',
                  selectable: true,
                  _styleGuide: null,
                  hideDesktop: false,
                  duplicatable: true,
                  containerPadding: '10px',
                  displayCondition: null,
                },
              },
              {
                id: '1jGDbp12Ub',
                type: 'heading',
                values: {
                  text: '<span>標題</span>',
                  _meta: {
                    htmlID: 'u_content_heading_1',
                    htmlClassNames: 'u_content_heading',
                  },
                  anchor: '',
                  fontSize: '22px',
                  hideable: true,
                  deletable: true,
                  draggable: true,
                  linkStyle: {
                    inherit: true,
                    linkColor: '#0000ee',
                    linkUnderline: true,
                    linkHoverColor: '#0000ee',
                    linkHoverUnderline: true,
                  },
                  textAlign: 'left',
                  _languages: {},
                  lineHeight: '140%',
                  selectable: true,
                  _styleGuide: null,
                  headingType: 'h1',
                  hideDesktop: false,
                  duplicatable: true,
                  containerPadding: '10px',
                  displayCondition: null,
                },
              },
              {
                id: 'TF1lxPpTSd',
                type: 'divider',
                values: {
                  _meta: {
                    htmlID: 'u_content_divider_1',
                    htmlClassNames: 'u_content_divider',
                  },
                  width: '100%',
                  anchor: '',
                  border: {
                    borderTopColor: '#BBBBBB',
                    borderTopStyle: 'solid',
                    borderTopWidth: '1px',
                  },
                  hideable: true,
                  deletable: true,
                  draggable: true,
                  textAlign: 'center',
                  selectable: true,
                  _styleGuide: null,
                  hideDesktop: false,
                  duplicatable: true,
                  containerPadding: '10px',
                  displayCondition: null,
                },
              },
              {
                id: 'geOS50_vnE',
                type: 'text',
                values: {
                  text: '<p style="line-height: 140%;">內容</p>',
                  _meta: {
                    htmlID: 'u_content_text_1',
                    htmlClassNames: 'u_content_text',
                  },
                  anchor: '',
                  fontSize: '14px',
                  hideable: true,
                  deletable: true,
                  draggable: true,
                  linkStyle: {
                    inherit: true,
                    linkColor: '#0000ee',
                    linkUnderline: true,
                    linkHoverColor: '#0000ee',
                    linkHoverUnderline: true,
                  },
                  textAlign: 'left',
                  _languages: {},
                  lineHeight: '140%',
                  selectable: true,
                  _styleGuide: null,
                  hideDesktop: false,
                  duplicatable: true,
                  containerPadding: '10px',
                  displayCondition: null,
                },
              },
              {
                id: 'footer_text_1',
                type: 'text',
                values: {
                  text: '<p style="line-height: 140%;">Super Vibes Team</p>',
                  _meta: {
                    htmlID: 'u_content_text_1',
                    htmlClassNames: 'u_content_text',
                  },
                  anchor: '',
                  fontSize: '14px',
                  hideable: true,
                  deletable: true,
                  draggable: true,
                  linkStyle: {
                    inherit: true,
                    linkColor: '#0000ee',
                    linkUnderline: true,
                    linkHoverColor: '#0000ee',
                    linkHoverUnderline: true,
                  },
                  textAlign: 'left',
                  _languages: {},
                  lineHeight: '140%',
                  selectable: true,
                  _styleGuide: null,
                  hideDesktop: false,
                  duplicatable: true,
                  containerPadding: '40px 10px 10px 10px',
                  displayCondition: null,
                  color: '#4C4687',
                },
              },
              {
                id: 'footer_text_2',
                type: 'text',
                values: {
                  text: '<p style="line-height: 140%;">appsupport@svgroup.hk</p>',
                  _meta: {
                    htmlID: 'u_content_text_2',
                    htmlClassNames: 'u_content_text',
                  },
                  anchor: '',
                  fontSize: '14px',
                  hideable: true,
                  deletable: true,
                  draggable: true,
                  linkStyle: {
                    inherit: true,
                    linkColor: '#0000ee',
                    linkUnderline: true,
                    linkHoverColor: '#0000ee',
                    linkHoverUnderline: true,
                  },
                  textAlign: 'left',
                  _languages: {},
                  lineHeight: '140%',
                  selectable: true,
                  _styleGuide: null,
                  hideDesktop: false,
                  duplicatable: true,
                  containerPadding: '10px',
                  displayCondition: null,
                  color: '#4C4687',
                },
              },
            ],
          },
        ],
      },
    ],
    values: {
      _meta: {
        htmlID: 'u_body',
        htmlClassNames: 'u_body',
      },
      language: {},
      linkStyle: {
        body: true,
        linkColor: '#0000ee',
        linkUnderline: true,
        linkHoverColor: '#0000ee',
        linkHoverUnderline: true,
      },
      textColor: '#000000',
      fontFamily: {
        label: 'Arial',
        value: 'arial,helvetica,sans-serif',
      },
      popupWidth: '600px',
      _styleGuide: null,
      popupHeight: 'auto',
      borderRadius: '10px',
      contentAlign: 'center',
      contentWidth: 'inherit',
      popupPosition: 'center',
      preheaderText: '',
      backgroundColor: '#F7F8F9',
      backgroundImage: {
        url: '',
        size: 'custom',
        repeat: 'no-repeat',
        position: 'center',
        fullWidth: true,
      },
      contentVerticalAlign: 'center',
      popupBackgroundColor: '#FFFFFF',
      popupBackgroundImage: {
        url: '',
        size: 'cover',
        repeat: 'no-repeat',
        position: 'center',
        fullWidth: true,
      },
      popupCloseButton_action: {
        name: 'close_popup',
        attrs: {
          onClick: 'document.querySelector(\'.u-popup-container\').style.display = \'none\';',
        },
      },
      popupCloseButton_margin: '0px',
      popupCloseButton_position: 'top-right',
      popupCloseButton_iconColor: '#000000',
      popupOverlay_backgroundColor: 'rgba(0, 0, 0, 0.1)',
      popupCloseButton_borderRadius: '0px',
      popupCloseButton_backgroundColor: '#DDDDDD',
    },
    footers: [],
    headers: [],
  },
  counters: {
    u_row: 1,
    u_column: 1,
    u_content_text: 1,
    u_content_image: 1,
    u_content_divider: 1,
    u_content_heading: 1,
  },
  schemaVersion: 17,
};
